import BaseTagger from './BaseTagger';

export default class ObjectDataTagger extends BaseTagger {
  /**
   * Tagging a structured event.
   * {@link https://docs.snowplowanalytics.com/docs/collecting-data/collecting-from-own-applications/javascript-tracker/tracking-specific-events/#Tracking_custom_structured_events|Documentation}
   * @param {object} data
   * @param {string} data.category
   * @param {string} data.action
   * @param {string|null} data.label
   * @param {string|null} data.property
   * @param {string|null} data.value
   */
  trackStructuredEvent(data) {
    super.trackStructuredEvent(data.category, data.action, data.label, data.property, data.value);
  }

  addDealerContext(data) {
    throw new Error('Method not implemented yet');
  }
}
